<template>
  <ankh-list>
    <template #btn-group>
      <el-radio-group v-model="tabCurrent">
        <el-radio-button label="import">{{$t('导入查询')}}</el-radio-button>
        <el-radio-button label="link">{{$t('综合查询')}}</el-radio-button>
      </el-radio-group>
    </template>
    <template #search-form>
      <el-form-item :label="$t('mac码')">
        <el-input clearable :placeholder="$t('mac码')" v-model="searchForm.likeMacCode" />
      </el-form-item>

      <el-form-item :label="$t('时间')">
        <date-time-range-picker :start-time.sync="searchForm.startCreateTime" :end-time.sync="searchForm.endCreateTime"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #tab-row>
      <div class="flex mb8" v-show="tabCurrent === 'import'">
        <el-button @click="showDialog = true" size="small">{{$t('导入')}}</el-button>
        <el-button @click="handleDownloadTemplate" size="small">{{$t('模版下载')}}</el-button>
      </div>
    </template>

    <template #table="{height}">
      <component :is="comps[tabCurrent]" :height="height" :searchParams="searchForm" ref="list" />
    </template>

    <template #other>
      <el-dialog :visible.sync="showDialog" :title="$t('导入')">
        <el-form label-width="auto">
          <el-form-item :label="$t('选择文件')">
            <el-upload
                ref="upload"
                accept=".xlsx, .xls"
                :limit="1"
                :auto-upload="false"
                :on-success="handleUploadSuccess"
                :action="$api.mac.importData">
              <el-button size="small" type="primary">{{$t('点击上传')}}</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button size="mini" type="primary" @click="$refs.upload.submit();">{{$t('确定')}}</el-button>
          <el-button size="mini" @click="showDialog = false">{{$t('取消')}}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import AnkhList from "@/components/list/AnkhList.vue";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker.vue";
import ImportCodeList from "@/components/mac-code/ImportCodeList.vue";
import CodeList from "@/components/mac-code/CodeList.vue";

export default {
  name: "MacCodeList",
  components: {CodeList, ImportCodeList, DateTimeRangePicker, AnkhList},
  data() {
    return {
      searchForm: {},
      showDialog: false,
      tabCurrent: "import",
      comps: {
        "import": ImportCodeList,
        "link": CodeList,
      }
    }
  },
  methods: {
    // 下载模版
    handleDownloadTemplate() {
      let baseUrl = this.$api.$base.root;
      if (baseUrl.endsWith('/api')) {
        baseUrl = baseUrl.slice(0, -4);
      }
      const a = document.createElement('a');
      a.href = `${baseUrl}/template/mac.xlsx`;
      a.download = 'mac模版.xlsx';
      a.click();
    },

    // 上传文件成功
    handleUploadSuccess(res) {
      if(res.status !== 200) {
        this.$message.success(res.desc || this.$t("导入失败"))
        return;
      }
      this.$message.success(this.$t("导入成功"));
      this.$refs.list.handleSearch();
      this.showDialog = false;
    },
  },
}
</script>

<style scoped>

/deep/.el-dialog {
  width: 380px;
  border-radius: 12px;
}
</style>
